import { IntlShape } from 'react-intl';

import {
  ActivityGroup,
  CHANGED_GROUP_MESSAGES,
} from './OnboardingActivities.constant';

const CHANGED_GROUPS_LIST_TYPE = 'conjunction';

interface FormatChangedGroupsArgs {
  intl: IntlShape;
  changedGroups: ActivityGroup[];
}

export const formatChangedGroups = ({
  intl,
  changedGroups,
}: FormatChangedGroupsArgs): string =>
  intl.formatList(
    changedGroups.map((group) =>
      intl.formatMessage(CHANGED_GROUP_MESSAGES[group]),
    ),
    { type: CHANGED_GROUPS_LIST_TYPE },
  );
